import { getAccessToken } from "@/utils/tokenManager";
import type { AuthHeaders, ManifestLevel } from "../types";

export const DEFAULT_QUALITY = "auto";

export const formatHeightLabel = (height?: number | string | null) => {
  if (!height) return null;
  const numericHeight = typeof height === "string" ? parseInt(height, 10) : height;
  if (!numericHeight || Number.isNaN(numericHeight)) return null;
  return `${numericHeight}p`;
};

export const getQualityLabel = (level: ManifestLevel, fallbackIndex: number) => {
  const byHeight = formatHeightLabel(level.height ?? null);
  if (byHeight) return byHeight;

  const resolutionAttr = level.attrs?.RESOLUTION;
  if (typeof resolutionAttr === "string") {
    const [, heightPart] = resolutionAttr.split("x");
    const fromResolution = formatHeightLabel(heightPart);
    if (fromResolution) return fromResolution;
  }

  return `Level ${fallbackIndex + 1}`;
};

export const formatTime = (time: number): string => {
  if (isNaN(time)) return "0:00";
  const minutes = Math.floor(time / 60);
  const seconds = Math.floor(time % 60);
  return `${minutes}:${seconds.toString().padStart(2, "0")}`;
};

export const formatSecondsToHMS = (timeInSeconds: number): string => {
  if (!Number.isFinite(timeInSeconds)) return "00:00:00";
  const totalSeconds = Math.max(0, Math.floor(timeInSeconds));
  const hours = Math.floor(totalSeconds / 3600)
    .toString()
    .padStart(2, "0");
  const minutes = Math.floor((totalSeconds % 3600) / 60)
    .toString()
    .padStart(2, "0");
  const seconds = Math.floor(totalSeconds % 60)
    .toString()
    .padStart(2, "0");

  return `${hours}:${minutes}:${seconds}`;
};

export const buildAuthHeaders = (headers?: Record<string, string>): AuthHeaders => {
  const token = getAccessToken();
  if (token && !(headers && "Authorization" in headers)) {
    return {
      ...(headers ?? {}),
      Authorization: `Bearer ${token}`,
    };
  }

  return headers ?? {};
};
